import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
} from '@mui/material';

const bulletinsData = [
  {
    title: "Population des Enfants par Tranches d'Age",
    description: "Explorez les données détaillées sur la population infantile, ventilées par tranches d'âge spécifiques, offrant ainsi une base solide pour des analyses ciblées et des interventions adaptées aux besoins des jeunes générations.",
    link: "/documents/ProjectionAgeSpecifiques/Population-des-enfants-des-tranches-dâges-de-déparasitage.xlsx",
  },
  {
    title: "Population des Jeunes et Adolescents par Province Selon le Sexe",
    description: "Accédez à une analyse approfondie de la population des jeunes et adolescents, stratifiée par sexe et par province, permettant ainsi de mieux comprendre les dynamiques démographiques régionales et d'orienter les politiques en faveur de cette tranche d'âge.",
    link: "/documents/ProjectionAgeSpecifiques/Population-des-jeunes-et-adolescents-par-province-selon-le-sexe.xlsx",
  },
  {
    title: "Population des Personnes âgées par Province Selon le Sexe",
    description: "Découvrez une évaluation précise de la population des personnes âgées, avec une distinction claire par province et par sexe, offrant ainsi des informations précieuses pour la planification des services de santé et de soutien adaptés à cette population.",
    link: "/documents/ProjectionAgeSpecifiques/Population-des-personnes-âgées-par-province-selon-le-sexe.xlsx",
  },
  {
    title: "Population en Age d'Alphabétisation par Province et Selon le Sexe",
    description: "Consultez les statistiques essentielles sur les personnes en âge d'alphabétisation, ventilées par province et par sexe, permettant ainsi de cibler efficacement les programmes d'éducation et de formation pour améliorer les compétences en lecture et en écriture.",
    link: "/documents/ProjectionAgeSpecifiques/Population-en-âge-dalphabétisation-par-provinceet-selon-le-sexe.xlsx",
  },
  {
    title: "Population en Age Scolaire par Province Selon le Sexe",
    description: "Consultez la répartition détaillée de la population en âge scolaire, par province et par sexe, facilitant ainsi la planification des ressources éducatives et l'amélioration de l'accès à l'enseignement pour tous les enfants et adolescents.",
    link: "/documents/ProjectionAgeSpecifiques/Population-en-âge-scolaire-par-province-selon-le-sexe.xlsx",
  },
  {
    title: "Population Féminine en Age de Procréer par Province et par Sexe",
    description: "Analysez les données spécifiques sur les femmes en âge de procréer, ventilées par province, offrant ainsi des informations cruciales pour la planification des services de santé reproductive et maternelle, ainsi que pour la promotion de la santé des femmes.",
    link: "/documents/ProjectionAgeSpecifiques/Population-féminine-en-âge-de-procréer-par-province-et-par-sexe.xlsx",
  },
  {
    title: "Population Infantile et Juvénile par Province Selon le Sexe",
    description: "Explorez une analyse complète de la population infantile et juvénile, stratifiée par province et par sexe, permettant ainsi d'identifier les besoins spécifiques de chaque région et d'adapter les politiques en faveur des jeunes générations.",
    link: "/documents/ProjectionAgeSpecifiques/Population-infantile-et-juvénile-par-province-selon-le-sexe.xlsx",
  },
  {
    title: "Population Majeure par Province Selon le Sexe",
    description: "Accédez aux données démographiques essentielles sur la population majeure, réparties par province et par sexe, offrant ainsi une base solide pour la planification des services sociaux, économiques et de santé adaptés aux adultes.",
    link: "/documents/ProjectionAgeSpecifiques/Population-majeure-par-province-selon-le-sexe.xlsx",
  },
  {
    title: "Populations Active et Inactive par Province Selon le Sexe",
    description: "Étudiez une analyse détaillée des populations actives et inactives, ventilées par province et par sexe, permettant ainsi de comprendre les dynamiques du marché du travail et d'orienter les politiques en faveur de l'emploi et de la formation professionnelle.",
    link: "/documents/ProjectionAgeSpecifiques/Populations-active-et-inactive-par-province-selon-le-sexe.xlsx",
  }
];

function ProjectionAgeSpecifique() {
  const [visibleBulletins, setVisibleBulletins] = useState(2);

  const handleLoadMore = () => {
    setVisibleBulletins(prev => Math.min(prev + 2, bulletinsData.length));
  };

  const bulletins = bulletinsData.slice(0, visibleBulletins);

  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Projections démographiques par âges spécifiques
        </Typography>
        <Typography variant="body1" align="justify" paragraph >
         Cette section présente les projections de la population du Burundi, stratifiées par tranches d'âge spécifiques.
        </Typography>
        <Grid container spacing={1} style={{ marginTop: '10px' }}>
          {bulletins.map((bulletin, index) => (
            <Grid item xs={12} key={index}>
              <Card variant="outlined" style={{ borderRadius: '8px', padding: '16px' }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4}>
                    <CardMedia
                      component="img"
                      height="140"
                      image="asset/cover/cover.jpg"
                      alt="Cover"
                      style={{ objectFit: 'cover', cursor: 'pointer' }}
                      onClick={() => window.open(bulletin.link, '_blank')}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <CardContent>
                      <Typography
                        variant="h5"
                        component="div"
                        style={{
                          fontWeight: 'bold',
                          marginBottom: '8px',
                          color: '#388E3C',
                          cursor: 'pointer'
                        }}
                        onClick={() => window.open(bulletin.link, '_blank')}
                      >
                         {<DownloadIcon />}{bulletin.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {bulletin.description}
                      </Typography>
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
        {visibleBulletins < bulletinsData.length && (
          <Box display="flex" justifyContent="left" mt={2}>
            <Button
              variant="contained"
              style={{ backgroundColor: '#388E3C', color: 'white' }}
              onClick={handleLoadMore}
            >
              Plus de rapports
            </Button>
          </Box>
        )}
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default ProjectionAgeSpecifique;